// eslint-disable-next-line no-restricted-imports
import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import { isLength, isNotEmpty, validateRecord } from '@gonfalon/legacy-form-validation/validationUtils';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

export class MFAVerification extends Record({
  passcode: '',
}) {
  validate() {
    return validateRecord(this, isNotEmpty('passcode'), isLength(6)('passcode'));
  }
}

export class MFARecovery extends Record({
  code: '',
}) {
  validate() {
    return validateRecord(this, isNotEmpty('code'));
  }
}

type MFARecoveryCodesType = {
  recoveryCodes: List<string>;
};

export class MFARecoveryCodes extends Record<MFARecoveryCodesType>({
  recoveryCodes: List(),
}) {}

export function createMFAVerification(props = {}) {
  return new MFAVerification(props);
}

export function createMFARecovery(props = {}) {
  return new MFARecovery(props);
}

export function createMFARecoveryCodes(props: CreateFunctionInput<MFARecoveryCodesType> = {}) {
  return new MFARecoveryCodes(fromJS(props));
}
